<template>
  <div
    v-if="alertText && typeof(alertText)==='string'"
    class="alert-banner">
    <p class="alert-banner__content">
      {{ alertText }}
    </p>
  </div>
</template>

<script>
import api from '../utils/api';

export default {
  name: 'AlertBanner',
  data() {
    return {
      alertText: {},
    };
  },
  created() {
    api.getData('/storefront/')
      .then((res) => {
        this.alertText = res.data.alertBanner;
      });
    // .catch((error) => {
    //   console.log(error);
    // });
  },
};
</script>

<style lang="stylus" scoped>
@require('../stylus/base')

.alert-banner
  display: flex
  flex-flow: row nowrap
  align-items: center
  justify-content: center

  color: $secondary
  background-color: $primary

  padding: $base-padding*.5

  &__content
    margin: 0
    font-size: $font-size--small
    letter-spacing: normal
    font-weight: $base-header-font-weight
    // font-style: italic


// PRINTER STYLES
@media print
  .alert-banner
    display: none
</style>
